import { mockQuoteDetailsFTSinglePayment } from '@domgen/dgx-fe-basket';
import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { RegistrationRequest } from '../../models/registration/registration-request.interface';
import { mockRegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.mock';

export const mockRegistrationRequest: RegistrationRequest = {
  basketItemId: mockRegistrationApplianceDetails.basketItemId,
  item: mockRegistrationApplianceDetails,
  person: mockCustomerDetails,
  quote: mockQuoteDetailsFTSinglePayment,
};
